import { IconStar } from './Icons';

/** Two or three short press quotes right under the hero. Edited in the sheet's HERO QUOTES block. */
export default function Quotes({ quotes }) {
  if (!quotes.length) return null;
  const parts = [];
  quotes.slice(0, 3).forEach((q, i) => {
    if (i > 0) parts.push(<IconStar key={`s${i}`} className="quotes-star" />);
    parts.push(
      <blockquote key={q.key} className="quote">
        <p>“{q.quote}”</p>
        {q.source && <footer>{q.source}</footer>}
      </blockquote>
    );
  });
  return (
    <section className="quotes" aria-label="What people are saying">
      <div className="wrap quotes-row">{parts}</div>
    </section>
  );
}
